import Trends from "./components/Trends";

const TrendAndRecent = () => {
  return <Trends />;
};
export default TrendAndRecent;
